<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    align-content-start>
    <v-layout
      justify-center
      wrap>
      <v-flex>
        <formAdminDraftOpportunitiesTiles @select-draft-id="onSelectDraftId" />
        <formAdminDraftOpportunitiesDatatable
          ref="draftOpportunitiesDatatable"
          :selected-draft-id="selectedDraftId"
          :title="'List of Draft Registrations'"
          :type="'byAwsAgreement'"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    selectedDraftId: null
  }),
  computed: {
  },
  methods: {
    onSelectDraftId (draftId) {
      this.selectedDraftId = {
        value: draftId,
        requestedAt: Date.now()
      }

      this.$nextTick(() => {
        const datatable = this.$refs.draftOpportunitiesDatatable

        if (datatable && typeof datatable.scrollToSearchInput === 'function') {
          datatable.scrollToSearchInput()
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
